import React, { useRef, useState } from 'react';
import './ContactMapForm.css';
import { FaPhoneAlt, FaEnvelope, FaRegEnvelopeOpen } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ContactMapForm = () => {
  const fileInputRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    street: '',
    city: '',
    postcode: '',
    phone: '',
    email: '',
    message: '',
    nda: false,
  });

  const [file, setFile] = useState(null);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleFileChange = e => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) =>
      data.append(key, value)
    );

    if (file) {
      data.append('file', file);
    }

    try {
      const response = await fetch(
        'https://driveincarspa.com/submit-mapform.php',
        {
          method: 'POST',
          body: data,
        }
      );

      const text = await response.text();
      if (response.ok) {
        alert('Form submitted successfully!');
        setFormData({
          name: '',
          street: '',
          city: '',
          postcode: '',
          phone: '',
          email: '',
          message: '',
          nda: false,
        });
        setFile(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
      } else {
        alert('Submission failed. Please try again.');
        console.error(text);
      }
    } catch (err) {
      alert('An error occurred. Please try again later.');
      console.error(err);
    }
  };

  return (
    <div className="contactmap-root container">
      <div className="contactmap-left">
       <h1 className="contactmap-title">
  Get in <span className="highlight">touch</span>
</h1>

<div className="contactmap-subtitle">
  Talk to Us — The Future of Car Care Awaits.{" "}
  <Link to="/" className="link-text">
    Auto detailing service contact Bangalore
  </Link>{" "}
  |{" "}
  <Link to="/" className="link-text">
    Book car detailing service Bangalore
  </Link>
</div>
        <form className="contactmap-form" onSubmit={handleSubmit}>
          <input
            className="contactmap-input"
            type="text"
            name="name"
            placeholder="Contact name"
            required
            value={formData.name}
            onChange={handleChange}
          />
          <input
            className="contactmap-input"
            type="text"
            name="street"
            placeholder="Street"
            required
            value={formData.street}
            onChange={handleChange}
          />
          <div className="contactmap-row">
            <input
              className="contactmap-input"
              type="text"
              name="city"
              placeholder="City"
              required
              value={formData.city}
              onChange={handleChange}
            />
            <input
              className="contactmap-input"
              type="text"
              name="postcode"
              placeholder="Postcode"
              required
              value={formData.postcode}
              onChange={handleChange}
            />
          </div>
          <input
            className="contactmap-input"
            type="tel"
            name="phone"
            placeholder="Contact Phone"
            required
            value={formData.phone}
            onChange={handleChange}
          />
          <input
            className="contactmap-input"
            type="email"
            name="email"
            placeholder="E-mail"
            required
            value={formData.email}
            onChange={handleChange}
          />
          <textarea
            className="contactmap-input contactmap-textarea"
            name="message"
            placeholder="Let's talk about your idea"
            rows={2}
            value={formData.message}
            onChange={handleChange}
          />

          <div
            className="contactmap-upload-box"
            onClick={() => fileInputRef.current?.click()}
          >
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
            <div className="contactmap-upload-content">
              <FaRegEnvelopeOpen className="contactmap-upload-icon" />
              <span>{file ? file.name : 'Upload Additional file'}</span>
            </div>
          </div>

          <div className="contactmap-upload-note">
            Attach file. File size of your documents should not exceed 10MB
          </div>

          <label className="contactmap-checkbox-label">
            <input
              type="checkbox"
              className="contactmap-checkbox"
              name="nda"
              checked={formData.nda}
              onChange={handleChange}
            />
            I want to protect my data by signing an NDA
          </label>

          <button className="contactmap-submit" type="submit">
            SUBMIT
          </button>
        </form>

        <div className="contactmap-info-row">
          <FaPhoneAlt className="contactmap-info-icon" />
          <span className="contactmap-info-label">Phone</span>
          <a className="contactmap-info-value" href="tel:+918951509309">
            +91-8951509309
          </a>
        </div>

        <div className="contactmap-info-row">
          <FaEnvelope className="contactmap-info-icon" />
          <span className="contactmap-info-label">E-MAIL</span>
          <a
            className="contactmap-info-value"
            href="mailto:driveincarspa@gmail.com"
          >
            driveincarspa@gmail.com
          </a>
        </div>

        <div className="contactmap-info-row">
          <FaRegEnvelopeOpen className="contactmap-info-icon" />
          <span className="contactmap-info-label">HELPDESK</span>
          <a
            className="contactmap-info-value"
            href="mailto:helpdriveincarspa@gmail.com"
          >
            helpdriveincarspa@gmail.com
          </a>
        </div>
      </div>

      <div className="contactmap-right">
        <div className="contactmap-map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3883.36733223867!2d77.55674497589018!3d13.264970308376897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb1df1166bf4cd5%3A0x7e342fcc2e976626!2sArkiya%20Innovtions%20LLP!5e0!3m2!1sen!2sin!4v1753089094826!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
          <div className="contactmap-address-overlay">
            No: 38/A, Doddaballapur Integrated Textile Park Ltd SW 51, Apparel Park,
            <br />
            KIADB Industrial Area Phase 2
            <br />
            Doddaballapur, Bengaluru Rural District
            <br />
            Karnataka - 561203, India
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactMapForm;
